const SEK_TO_EUR_RATE = 1 / 11.07

export const fromEURtoSEK = (amount?: number) => {
  return Number((Math.round((amount || 0) * 11.07 * 100) / 100).toFixed(0))
}

/** Convert amount stored in SEK to target currency. Returns original if target is SEK. */
export const convertFromSEK = (
  amount: number | null | undefined,
  targetCurrency: string
): number | null | undefined => {
  if (amount == null) return amount
  if (targetCurrency === 'EUR') {
    return Number((Math.round(amount * SEK_TO_EUR_RATE * 100) / 100).toFixed(1))
  }
  return amount
}

export const getCurrencyForCountry = (countryCode: string): 'SEK' | 'EUR' => {
  return countryCode?.toUpperCase() === 'SE' ? 'SEK' : 'EUR'
}

export const getCurrencyForVisitor = async (): Promise<'SEK' | 'EUR'> => {
  try {
    const res = await fetch('https://ipapi.co/json/?fields=country_code')
    const data = await res.json()
    return getCurrencyForCountry(data?.country_code ?? '')
  } catch {
    return 'EUR'
  }
}
